import { Box, Typography } from "@mui/material";
import React from "react";

import { ChainCardRef } from "../ValueChain/valueChainState";
import OpenInValueChainLink from "./OpenInValueChainLink";
import { ON_RECORD, chainPlaceLine, usePageChain } from "./kindChain";

interface ChainPlaceProps {
  // The kind or the class as a root of the value chain
  root: ChainCardRef;
  // Its category id, by which the chain on the page names its card
  categoryId: string;
  // Whether it says where it sits in the chain the page shows; the kind
  // view says so in its counts instead
  withLine?: boolean;
}

/**
 * Where a kind or a class sits in the chain the page shows, and, from any
 * other page, the step into the value chain page. "Make root" is in the
 * header.
 */
const ChainPlace: React.FC<ChainPlaceProps> = ({
  root,
  categoryId,
  withLine = false,
}) => {
  const page = usePageChain();
  const line =
    withLine && page?.chain
      ? `${chainPlaceLine(page.chain, categoryId)} ${ON_RECORD}`
      : null;

  if (!line && page) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        columnGap: 2,
        rowGap: 1,
      }}
    >
      {line && (
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ flex: 1, minWidth: 200 }}
        >
          {line}
        </Typography>
      )}
      {/* On the value chain page the chain is open already */}
      {!page && <OpenInValueChainLink root={root} />}
    </Box>
  );
};

export default ChainPlace;
